import React, { Component } from 'react';

import TopNav from '../containers/navs/Topnav';
import Sidebar from '../containers/navs/Sidebar';

export default class AppLayout extends Component {
  render() {
    return (
      <div id="app-container" className="admin-menu">
        <Sidebar />
        <main className="app-main">
          <TopNav history={this.props.history} />
          <div className="container-fluid">{this.props.children}</div>
        </main>
      </div>
    );
  }
}
